import axios from 'axios';
import { navigate } from './navigationService';
import { saveReturnTo } from './returnTo';

export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds timeout
  withCredentials: true, // Send session cookies with requests
});

// Response interceptor - handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    if (error.response?.status === 401) {
      saveReturnTo(window.location.pathname + window.location.search);
      navigate('/login');
    }
    return Promise.reject(error);
  }
);

export default apiClient;
